export const SERVICE_UNAVAILABLE_RETRY_INTERVAL_SEC = 5;

export const getCountdownSeconds = (
  retryIntervalSec: number,
  elapsedMs: number
): number => {
  const intervalMs = retryIntervalSec * 1000;
  const remainingMs = intervalMs - (elapsedMs % intervalMs);

  if (remainingMs === intervalMs) {
    return retryIntervalSec;
  }

  return Math.ceil(remainingMs / 1000);
};
